import { render, staticRenderFns } from "./SubDivision.vue?vue&type=template&id=632eb566&"
import script from "./SubDivision.vue?vue&type=script&lang=js&"
export * from "./SubDivision.vue?vue&type=script&lang=js&"
import style0 from "./SubDivision.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports